import { call, put, takeLatest, takeEvery } from 'redux-saga/effects';
import { chatService } from './chat.service';
import { uploadFile } from '../index';
import { KeyPurpose } from 'utils';
import {
    GET_CHATS,
    GET_CHATS_SUCCESS,
    GET_CHAT_USERS,
    GET_CHAT_USERS_SUCCESS,
    CREATE_CHAT,
    CREATE_CHAT_SUCCESS,
    DELETE_CHAT,
    REMOVE_CHAT_MEMBER,
    REMOVE_CHAT_MEMBER_SUCCESS,
    ADD_CHAT_MEMBERS,
    ADD_CHAT_MEMBERS_SUCCESS,
    GET_MESSAGES,
    GET_MESSAGES_SUCCESS,
    SEND_MESSAGE,
    SEND_MESSAGE_SUCCESS,
    EDIT_MESSAGE,
    DELETE_MESSAGE,
    SEARCH_MESSAGES,
    SEARCH_MESSAGES_SUCCESS,
    UPLOAD_ATTACHMENT,
    MARK_CHAT_READ,
    MARK_MESSAGE_READ,
    MUTE_CHAT,
    MUTE_CHAT_SUCCESS,
} from './chat.types';
import { httpRequestsOnErrorsActions } from '../http_requests_on_errors';
import { httpRequestsOnLoadActions } from '../http_requests_on_load';
import { httpRequestsOnSuccessActions } from '../http_requests_on_success';

function* getChats({ payload, type }) {
    if (payload?.load !== 'noLoad') {
        yield put(httpRequestsOnLoadActions.appendLoading(type));
    }
    yield put(httpRequestsOnErrorsActions.removeError(type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(type));
    try {
        const res = yield call(chatService.getChatsService);
        yield put({
            type: GET_CHATS_SUCCESS,
            payload: res.data,
        });
        yield put(httpRequestsOnLoadActions.removeLoading(type));
    } catch (err) {
        const error = err?.data?.message ? err?.data?.message : err?.response?.data?.message;
        yield put(httpRequestsOnErrorsActions.appendError(type, error));
        yield put(httpRequestsOnLoadActions.removeLoading(type));
    }
}

function* getChatUsers({ payload, type }) {
    if (payload?.load !== 'noLoad') {
        yield put(httpRequestsOnLoadActions.appendLoading(type));
    }
    yield put(httpRequestsOnErrorsActions.removeError(type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(type));
    try {
        const res = yield call(chatService.getChatUsersService, payload?.params);
        yield put({
            type: GET_CHAT_USERS_SUCCESS,
            payload: res.data,
        });
        yield put(httpRequestsOnLoadActions.removeLoading(type));
    } catch (err) {
        const error = err?.data?.message ? err?.data?.message : err?.response?.data?.message;
        yield put(httpRequestsOnErrorsActions.appendError(type, error));
        yield put(httpRequestsOnLoadActions.removeLoading(type));
    }
}

function* createChat({ payload, type }) {
    yield put(httpRequestsOnLoadActions.appendLoading(type));
    yield put(httpRequestsOnErrorsActions.removeError(type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(type));
    try {
        const res = yield call(chatService.createChatService, payload?.body);
        yield put({
            type: CREATE_CHAT_SUCCESS,
            payload: res.data,
        });
        yield put(httpRequestsOnSuccessActions.appendSuccess(type));
        yield put(httpRequestsOnLoadActions.removeLoading(type));
    } catch (err) {
        const error = err?.data?.message ? err?.data?.message : err?.response?.data?.message;
        yield put(httpRequestsOnErrorsActions.appendError(type, error));
        yield put(httpRequestsOnLoadActions.removeLoading(type));
    }
}

function* deleteChat({ payload, type }) {
    yield put(httpRequestsOnLoadActions.appendLoading(type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(type));
    try {
        yield call(chatService.deleteChatService, payload?.chatId);
        const res = yield call(chatService.getChatsService);
        yield put({
            type: GET_CHATS_SUCCESS,
            payload: res.data,
        });
        yield put(httpRequestsOnSuccessActions.appendSuccess(type));
        yield put(httpRequestsOnLoadActions.removeLoading(type));
    } catch (err) {
        const error = err?.data?.message ? err?.data?.message : err?.response?.data?.message;
        yield put(httpRequestsOnErrorsActions.appendError(type, error));
        yield put(httpRequestsOnLoadActions.removeLoading(type));
    }
}

function* removeChatMember({ payload, type }) {
    yield put(httpRequestsOnLoadActions.appendLoading(type, payload));
    yield put(httpRequestsOnSuccessActions.removeSuccess(type));
    try {
        const res = yield call(chatService.removeChatMemberService, payload?.chatId, payload?.userId);
        yield put({ type: REMOVE_CHAT_MEMBER_SUCCESS, payload: res.data });
        yield put(httpRequestsOnSuccessActions.appendSuccess(type));
        yield put(httpRequestsOnLoadActions.removeLoading(type));
    } catch (err) {
        const error = err?.data?.message ? err?.data?.message : err?.response?.data?.message;
        yield put(httpRequestsOnErrorsActions.appendError(type, error));
        yield put(httpRequestsOnLoadActions.removeLoading(type));
    }
}

function* addChatMembers({ payload, type }) {
    yield put(httpRequestsOnLoadActions.appendLoading(type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(type));
    try {
        const res = yield call(chatService.addChatMembersService, payload?.chatId, payload?.participants);
        yield put({ type: ADD_CHAT_MEMBERS_SUCCESS, payload: res.data });
        yield put(httpRequestsOnSuccessActions.appendSuccess(type));
        yield put(httpRequestsOnLoadActions.removeLoading(type));
    } catch (err) {
        const error = err?.data?.message ? err?.data?.message : err?.response?.data?.message;
        yield put(httpRequestsOnErrorsActions.appendError(type, error));
        yield put(httpRequestsOnLoadActions.removeLoading(type));
    }
}

function* getMessages({ payload, type }) {
    if (payload?.load !== 'noLoad') {
        yield put(httpRequestsOnLoadActions.appendLoading(type));
    }
    yield put(httpRequestsOnErrorsActions.removeError(type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(type));
    try {
        const res = yield call(chatService.getMessagesService, payload?.chatId, payload?.params);
        yield put({
            type: GET_MESSAGES_SUCCESS,
            payload: { ...res.data, skip: payload?.params?.skip || 0 },
        });
        yield put(httpRequestsOnLoadActions.removeLoading(type));
    } catch (err) {
        const error = err?.data?.message ? err?.data?.message : err?.response?.data?.message;
        yield put(httpRequestsOnErrorsActions.appendError(type, error));
        yield put(httpRequestsOnLoadActions.removeLoading(type));
    }
}

function* sendMessage({ payload, type }) {
    yield put(httpRequestsOnLoadActions.appendLoading(type));
    yield put(httpRequestsOnErrorsActions.removeError(type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(type));
    try {
        const res = yield call(chatService.sendMessageService, payload?.chatId, payload?.body);
        yield put({
            type: SEND_MESSAGE_SUCCESS,
            payload: { ...res.data, chatId: res.data?.chatId || payload?.chatId },
        });
        yield put(httpRequestsOnSuccessActions.appendSuccess(type));
        yield put(httpRequestsOnLoadActions.removeLoading(type));
    } catch (err) {
        const error = err?.data?.message ? err?.data?.message : err?.response?.data?.message;
        yield put(httpRequestsOnErrorsActions.appendError(type, error));
        yield put(httpRequestsOnLoadActions.removeLoading(type));
    }
}

function* editMessage({ payload, type }) {
    yield put(httpRequestsOnLoadActions.appendLoading(type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(type));
    try {
        yield call(chatService.editMessageService, payload?.messageId, payload?.body);
        yield put(httpRequestsOnSuccessActions.appendSuccess(type));
        yield put(httpRequestsOnLoadActions.removeLoading(type));
    } catch (err) {
        const error = err?.data?.message ? err?.data?.message : err?.response?.data?.message;
        yield put(httpRequestsOnErrorsActions.appendError(type, error));
        yield put(httpRequestsOnLoadActions.removeLoading(type));
    }
}

function* deleteMessage({ payload, type }) {
    yield put(httpRequestsOnLoadActions.appendLoading(type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(type));
    try {
        yield call(chatService.deleteMessageService, payload?.messageId);
        yield put(httpRequestsOnSuccessActions.appendSuccess(type));
        yield put(httpRequestsOnLoadActions.removeLoading(type));
    } catch (err) {
        const error = err?.data?.message ? err?.data?.message : err?.response?.data?.message;
        yield put(httpRequestsOnErrorsActions.appendError(type, error));
        yield put(httpRequestsOnLoadActions.removeLoading(type));
    }
}

function* searchMessages({ payload, type }) {
    yield put(httpRequestsOnLoadActions.appendLoading(type));
    yield put(httpRequestsOnErrorsActions.removeError(type));
    try {
        const res = yield call(chatService.searchMessagesService, payload?.chatId, payload?.params);
        yield put({
            type: SEARCH_MESSAGES_SUCCESS,
            payload: res.data,
        });
        yield put(httpRequestsOnLoadActions.removeLoading(type));
    } catch (err) {
        const error = err?.data?.message ? err?.data?.message : err?.response?.data?.message;
        yield put(httpRequestsOnErrorsActions.appendError(type, error));
        yield put(httpRequestsOnLoadActions.removeLoading(type));
    }
}

function* uploadAttachment({ payload, type }) {
    yield put(httpRequestsOnLoadActions.appendLoading(type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(type));
    try {
        // Step 1: Upload each file via presigned direct-S3 PUT → get StoredFile[]
        const storedFiles = yield call(() =>
            Promise.all(payload.files.map((file) => uploadFile(file, KeyPurpose.CHAT_ATTACHMENT))),
        );

        // Step 2: Send a message with all files as attachments
        const attachments = storedFiles.map((storedFile) => ({
            file: storedFile,
            name: storedFile.originalName || 'file',
        }));
        const body = { text: '', attachments };
        const res = yield call(chatService.sendMessageService, payload?.chatId, body);
        yield put({
            type: SEND_MESSAGE_SUCCESS,
            payload: { ...res.data, chatId: res.data?.chatId || payload?.chatId },
        });
        yield put(httpRequestsOnSuccessActions.appendSuccess(type));
        yield put(httpRequestsOnLoadActions.removeLoading(type));
    } catch (err) {
        const error = err?.data?.message ? err?.data?.message : err?.response?.data?.message;
        yield put(httpRequestsOnErrorsActions.appendError(type, error));
        yield put(httpRequestsOnLoadActions.removeLoading(type));
    }
}

function* markChatRead({ payload, type }) {
    try {
        yield call(chatService.markReadService, payload?.chatId);
    } catch (err) {}
}

function* markMessageRead({ payload, type }) {
    try {
        yield call(chatService.markMessageReadService, payload?.messageId);
    } catch (err) {}
}

function* muteChat({ payload, type }) {
    yield put(httpRequestsOnLoadActions.appendLoading(type, { chatId: payload?.chatId }));
    yield put(httpRequestsOnSuccessActions.removeSuccess(type));
    try {
        const res = yield call(chatService.muteChatService, payload?.chatId, payload?.muted);
        yield put({
            type: MUTE_CHAT_SUCCESS,
            payload: { chatId: payload?.chatId, muted: payload?.muted },
        });
        yield put(httpRequestsOnSuccessActions.appendSuccess(type));
        yield put(httpRequestsOnLoadActions.removeLoading(type));
    } catch (err) {
        const error = err?.data?.message ? err?.data?.message : err?.response?.data?.message;
        yield put(httpRequestsOnErrorsActions.appendError(type, error));
        yield put(httpRequestsOnLoadActions.removeLoading(type));
    }
}

export const watchChat = function* watchChatSaga() {
    yield takeLatest(GET_CHATS, getChats);
    yield takeLatest(GET_CHAT_USERS, getChatUsers);
    yield takeLatest(CREATE_CHAT, createChat);
    yield takeLatest(DELETE_CHAT, deleteChat);
    yield takeEvery(REMOVE_CHAT_MEMBER, removeChatMember);
    yield takeLatest(ADD_CHAT_MEMBERS, addChatMembers);
    yield takeLatest(GET_MESSAGES, getMessages);
    yield takeEvery(SEND_MESSAGE, sendMessage);
    yield takeLatest(EDIT_MESSAGE, editMessage);
    yield takeLatest(DELETE_MESSAGE, deleteMessage);
    yield takeLatest(SEARCH_MESSAGES, searchMessages);
    yield takeEvery(UPLOAD_ATTACHMENT, uploadAttachment);
    yield takeLatest(MARK_CHAT_READ, markChatRead);
    yield takeLatest(MARK_MESSAGE_READ, markMessageRead);
    yield takeLatest(MUTE_CHAT, muteChat);
};
